import React, {Component} from "react";
import * as auth from "../../store/ducks/auth.duck";
import {connect} from "react-redux";
import {Redirect, withRouter} from "react-router-dom";
import {LayoutSplashScreen} from "../../../_metronic";
import axios from "axios";

class Logout extends Component {

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_BASE_TEST}/logout`).then(() => {
            this.props.logout();
        }).catch(() => {
            this.props.logout();
        });

        setTimeout(() => {
            this.props.history.push('/auth/login');
        }, 200);
    }

    render() {
        const {hasAuthToken} = this.props;

        return hasAuthToken ? <LayoutSplashScreen/> : <Redirect to="/auth"/>;
    }
}

export default withRouter(connect(
    ({auth}) => ({hasAuthToken: Boolean(auth.authToken)}),
    auth.actions
)(Logout));
